
<p>{{result}}</p>

<button (click) = "sendData()">click me</button>